import React from 'react';

import { Skeleton } from 'antd';

export default function TextSkeleton() {
  return <Skeleton.Input size="small" />;
}
